(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    // Mobile only
    if (!window.matchMedia("(max-width: 768px)").matches) return;

    const bar = document.querySelector("[data-tp-sticky-atc]");
    if (!bar) return;

    // Primary: explicit ATC button (we added data-tp-real-atc in buy-buttons.liquid)
    let atcBtn = document.querySelector("[data-tp-real-atc]");

    // Fallback: find within product form
    const form =
      document.querySelector('form[action^="/cart/add"]') ||
      document.querySelector("product-form form");

    if (!atcBtn && form) {
      atcBtn =
        form.querySelector('button[name="add"]') ||
        form.querySelector(".product-form__submit") ||
        form.querySelector('button[type="submit"], input[type="submit"]');
    }

    if (!atcBtn) return;

    const stickyBtn = bar.querySelector("[data-tp-sticky-btn]");
    if (stickyBtn) {
      stickyBtn.addEventListener("click", function () {
        atcBtn.click();
      });
    }

    const footer = document.querySelector("footer");

    function inView(el) {
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > 0 && r.top < vh;
    }

    function update() {
      const atcVisible = inView(atcBtn);
      const footerVisible = footer ? inView(footer) : false;

      const shouldShow = !atcVisible && !footerVisible;
      bar.style.display = shouldShow ? "block" : "none";

      // Reserve space only when sticky is shown
      document.body.classList.toggle("tp-sticky-atc-on", shouldShow);
    }

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    // If form exists, update after variant/qty changes (layout can shift)
    if (form) {
      form.addEventListener("change", function () {
        setTimeout(update, 50);
      });
    }
  });
})();
